import { useEffect } from 'react';
import { useMessageStore } from '@connect-x-app/hybrid-state';

export const useAppStateReconnect = () => {
  const { updatePendingMessagesToFailed } = useMessageStore();

  useEffect(() => {
    updatePendingMessagesToFailed();
    const timerId = setTimeout(() => {
      updatePendingMessagesToFailed();
    }, 60000);

    return () => {
      clearTimeout(timerId);
    };
  }, [updatePendingMessagesToFailed]);
};
